import { createConfig, http } from 'wagmi';
import { injected } from 'wagmi/connectors';
import { mainnet, sepolia } from 'viem/chains';
import { getDefaultConfig } from '@rainbow-me/rainbowkit';

// Check if Rainbow Wallet is available
const isRainbowAvailable = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (window as any).ethereum?.isRainbow === true;
};

// Create wagmi config - use RainbowKit's getDefaultConfig if Rainbow is detected
// Otherwise use standard wagmi config with injected connector
export const wagmiConfig = (() => {
  if (isRainbowAvailable()) {
    // Use RainbowKit's getDefaultConfig when Rainbow is detected
    // This automatically sets up wagmi with RainbowKit support
    return getDefaultConfig({
      appName: 'Morpheum DEX',
      projectId: '892c8c1d9d78f8ec09adb7799d846b78', // You may want to add this to env
      chains: [mainnet, sepolia],
      ssr: false, // Set to true if using SSR
    });
  } else {
    // Standard wagmi config with injected connector
    // Supports: MetaMask, Phantom, OneKey, OKX, Rainbow, and other wallets
    // The injected connector will detect these wallets when available
    // Wagmi v3: injected() connector automatically detects all injected wallets
    return createConfig({
      chains: [mainnet, sepolia],
      connectors: [
        injected({
          // In Wagmi v3, injected connector automatically detects:
          // - MetaMask (window.ethereum?.isMetaMask)
          // - Phantom (window.phantom?.ethereum or window.ethereum?.isPhantom)
          // - OneKey (window.$onekey?.ethereum or window.ethereum?.isOneKey)
          // - OKX (window.okxwallet?.ethereum or window.ethereum?.isOKX)
          // - Rainbow (window.ethereum?.isRainbow)
          // - Any other EIP-1193 compatible wallet
        }),
      ],
      transports: {
        [mainnet.id]: http(),
        [sepolia.id]: http(),
      },
    });
  }
})();

